import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitArrayBy',
  standalone: true,
})
export class SplitArrayByPipe implements PipeTransform {
  transform<T>(array: T[], by = 2): T[][] {
    by = Math.round(by);
    const newArray: T[][] = [];
    array.forEach((_, index) => {
      if (index % by === 0) {
        newArray.push(array.slice(index, index + by));
      }
    });

    return newArray;
  }
}
